import type { InsuranceParamsLeasingDto } from 'BrokerTsLib/src/dtos'
import { SelectionType } from 'BrokerTsLib/src/enums'
import { format } from 'date-fns'

import { usePriceFormat } from '@/hooks/usePriceFormat'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import { useSelections } from '.'
import type { InsuranceInfoProps } from '../components/InsuranceInfo'

export const useInsuranceInfo: (insuranceParams?: InsuranceParamsLeasingDto) => InsuranceInfoProps[] = (insuranceParams?: InsuranceParamsLeasingDto) => {
  const { translate } = useTranslationsContext()
  const { priceFormat } = usePriceFormat()
  const { data: dataLt } = useSelections(SelectionType.LeasingType)
  const { data: dataPf } = useSelections(SelectionType.FrekvencePlatby)
  const leasingTypes = dataLt?.data ?? []
  const paymentFrequencies = dataPf?.data ?? []

  if (!insuranceParams) return []

  const infos = []

  if (insuranceParams.generalParams.insuranceStartDate) {
    const date = new Date(insuranceParams.generalParams.insuranceStartDate)
    date.setHours(0, 0, 0, 0)

    const now = new Date()
    now.setHours(0, 0, 0, 0)
    infos.push({
      label: translate('insuranceStartDate', 'Počátek pojištění'),
      value: format(date, 'd. M. yyyy'),
      hasWarning: date < now,
    })
  }

  if (insuranceParams.vehicle.price)
    infos.push({
      label: translate('insuranceAmmount', 'Pojistná částka'),
      value: `${priceFormat(insuranceParams.vehicle.price)} ${insuranceParams.vehicle.priceIncludeVat ? translate('withVat', 's DPH') : translate('withoutVat', 'bez DPH')}`,
    })

  if (insuranceParams.leasingTypeId)
    infos.push({
      label: translate('leasingType', 'Typ financování'),
      value: leasingTypes.find(x => x.id == insuranceParams.leasingTypeId)?.description ?? '',
    })

  if (insuranceParams.leasingTerm)
    infos.push({
      label: translate('leasingTerm', 'Délka financování'),
      value: `${insuranceParams.leasingTerm} ${translate('months', 'měsíců').toLocaleLowerCase()}`,
    })

  if (insuranceParams.generalParams.paymentFrequency)
    infos.push({
      label: translate('paymentFrequency', 'Frekvence placení'),
      value: paymentFrequencies.find(x => x.id == insuranceParams.generalParams.paymentFrequency)?.description ?? '',
    })

  return infos
}
